import type { ReactNode } from "react"
import { Button } from "@/components/ui/button"

interface EmptyListProps {
  /** Rounded icon tile above the title (e.g. a category glyph). */
  icon?: ReactNode
  /** Bold call-to-action line, e.g. "Add your glasses product in Try On". */
  title?: string
  /** Optional secondary muted line. */
  text?: string
  addText: string
  onClick: () => void
  showAdd: boolean
}

const EmptyList = ({ icon, title, text, addText, onClick, showAdd }: EmptyListProps) => (
  <div className="flex flex-col items-center justify-center gap-5" data-testid="empty-list">
    {icon ? (
      <div className="flex size-24 items-center justify-center rounded-2xl bg-empty-tile">
        {icon}
      </div>
    ) : null}
    {title ? <p className="text-center text-xl font-semibold">{title}</p> : null}
    {text ? (
      <p className="max-w-[500px] text-center text-sm text-muted-foreground">{text}</p>
    ) : null}
    {showAdd ? (
      <Button
        size="lg"
        className="bg-vto-accent text-vto-accent-foreground shadow-sm hover:bg-vto-accent/90 focus-visible:ring-vto-accent"
        onClick={onClick}
        data-testid="empty-list-action"
      >
        {addText}
      </Button>
    ) : null}
  </div>
)

export default EmptyList
